import { AloBaseLg, getDefaultAloBaseLg } from "./AloBaseLg"


export interface AloArboLg extends AloBaseLg  {        
}

export const getDefaultAloArboLg = ():AloArboLg => {
    return {
        ...getDefaultAloBaseLg("en")
    }
}